import type { CpRgLimitsParallelTimeValuesApiKind } from '../types';

export const rgLimitsParallelTimeValuesApiKind: CpRgLimitsParallelTimeValuesApiKind = 'minutes';
